export default "__VITE_ASSET__DuCOfpg9__"